// src/pages/expense/env/disinfection/envDisinfectionConfig.js
// ✅ 전 사업 확산 [2] — 환경/소독 사업의 businessConfig. 환경/종합과 동일한 공통
// 컴포넌트(pages/expense/_shared/ExpenseDraft*.jsx)에 이 config를 넘긴다.
// 템플릿 5종은 소독 지출 데이터(EnvDisinfectionExpense) 실측 27건 근거로 구성
// (완료 보고의 사업별 템플릿 대조표 참고) — 유류비/계약인지세는 기존 fuel_cost/
// service_contract를 그대로 재사용(둘 다 범용 템플릿, env_total도 동일하게 재사용).
import { makeExpenseDraftConfig } from "../../_shared/expenseDraftConfig";
import VendorPanel from "../../_shared/VendorPanel";
import ExpenseItemPanel from "../../_shared/ExpenseItemPanel";
import SalaryPanel from "./SalaryPanel";

// ── 5종 + 기타 그리드 (Intl.Collator("ko") 정렬 검증 완료: 계약인지세/수수료 정산/
// 유류비(세차비)/임직원급여/차량정비비, DocumentTypeSelector.jsx와 동일 순서) ──
const TEMPLATES = [
  { code: "service_contract", label: "계약인지세" },
  { code: "env_disinfection_commission_settlement", label: "수수료 정산" },
  { code: "fuel_cost", label: "유류비(세차비)" },
  { code: "env_disinfection_payroll", label: "임직원급여" },
  { code: "env_disinfection_vehicle_maintenance", label: "차량정비비" },
];

// ✅ 종류 선택 시 자동 채워지는 구분/내용/분야 — DB 실측(27건) 근거 기본값,
// 전부 자유 수정 가능.
// 2026-07-30 — category_name을 예산과목 마지막 항목과 일치시킴(대조표 조사
// 결과 반영). env_disinfection_payroll은 (급여↔보수) 회계 확인 후 별도 지시
// 예정이라 보류, 기존 값 유지. service_contract는 예산과목 필드 자체가 없어
// 비교 대상 아님.
const CATEGORY_ITEM_FIELD_DEFAULTS = {
  service_contract: { category_name: "공공운영비", item_name: "인지세", field_name: "지출" },
  env_disinfection_commission_settlement: {
    category_name: "지급수수료",
    item_name: "(정산 용도)수수료 합계",
    field_name: "정산",
  },
  fuel_cost: { category_name: "차량선박비", item_name: "유류비", field_name: "지출" },
  env_disinfection_payroll: { category_name: "급여", item_name: "", field_name: "지급" }, // ⏸ 보류(급여↔보수, 회계 확인 예정)
  env_disinfection_vehicle_maintenance: { category_name: "차량유지비", item_name: "", field_name: "지출" },
};

// ✅ 구매/계약성 4종 — 품목 표(ExpenseItemPanel)로 이용내역 이체+자동 합산(다른
// 사업과 동일 관례). 임직원급여만 인건비 명단(SalaryPanel)을 쓴다.
const ITEM_PANEL_TEMPLATES = [
  "service_contract",
  "env_disinfection_commission_settlement",
  "fuel_cost",
  "env_disinfection_vehicle_maintenance",
];
const SALARY_PANEL_TEMPLATES = ["env_disinfection_payroll"];

// ✅ 유류비 차량 기본값 — 환경/소독도 환경/종합(포터)과 동일하게 1사업 1차량
// 원칙 적용(2026-07-30 신규 적용). 자동완성으로 다른 차량 선택/직접 입력도 가능.
const TEMPLATE_FIELD_OVERRIDES = {
  fuel_cost: { carNumber: "174나3702", carModel: "레이", carInput: "174나3702(레이)" },
};

const envDisinfectionConfig = makeExpenseDraftConfig({
  namespace: "env-disinfection-draft",
  category: "환경/소독",
  businessLabel: "환경/소독",
  // ✅ (구) 페이지가 실제로 쓰는 EnvDisinfectionExpense.draft_no 접두어와 정확히
  // 일치(DB 실측: 기존 27건 전부 "금천일자리(주)환경/소독지출").
  draftNoPrefix: "금천일자리(주)환경/소독지출",
  dataApiBase: "/expense/env/disinfection/",
  combinedCreateApi: "/expense/env/disinfection/draft/",
  newRoutePath: "/expense/env/disinfection/draft/new",
  listRoutePath: "/expense/env/disinfection/draft/list",
  previewRoutePath: "/expense/env/disinfection/draft/preview",
  templates: TEMPLATES,
  categoryItemFieldDefaults: CATEGORY_ITEM_FIELD_DEFAULTS,
  itemPanelTemplates: ITEM_PANEL_TEMPLATES,
  salaryPanelTemplates: SALARY_PANEL_TEMPLATES,
  templateFieldOverrides: TEMPLATE_FIELD_OVERRIDES,
  // fieldNameMap 생략 — EnvDisinfectionExpenseSerializer가 이미 category_name/
  // item_name/field_name으로 env_total과 동일하게 노출하므로 기본값 그대로 사용.
  VendorPanel,
  ExpenseItemPanel,
  SalaryPanel,
});

export default envDisinfectionConfig;
